// Shown when a pick makes BOTH a client's invoice and statement delivery Email in the Billing Review
// drill-down (with only one on Email nothing is asked). Email needs somewhere to go, so the three
// addresses PE keeps for the client are shown (pre-filled with what PE holds today) and ALL of them
// must be filled in before the change can be submitted. They travel with the staged change — once,
// on the pick that completes the pair — and are written to PE together with the format once the
// Billing Team approves (api/shared/billingConfig/peDeliveryFormat.js).

import React, { useState } from 'react';
import Modal from '../../components/Modal';
import { isValidEmail } from './ClientContactCreateRecord';

// payload key (server) · client row field (PE column) · label the user sees
export const DELIVERY_EMAIL_FIELDS = [
  { key: 'creditEmail',    prop: 'ClientCreditEmail',    label: 'Credit Email' },
  { key: 'billingEmail',   prop: 'ClientBillingEmail',   label: 'Billing Email' },
  { key: 'statementEmail', prop: 'ClientStatementEmail', label: 'Statement Email' },
];

// PE keeps several addresses in one field: ';' or ',' separate them and each must be an address.
const problemWith = v => {
  const s = String(v || '').trim();
  if (!s) return 'Required';
  const parts = s.split(/[;,]/).map(p => p.trim()).filter(Boolean);
  return parts.length && parts.every(isValidEmail) ? '' : 'Enter a valid e-mail address';
};

export default function DeliveryEmailModal({ client, onCancel, onSubmit }) {
  const [values, setValues] = useState(() => Object.fromEntries(
    DELIVERY_EMAIL_FIELDS.map(f => [f.key, String(client[f.prop] || '').trim()])));
  const [touched, setTouched] = useState({});

  const problems = Object.fromEntries(DELIVERY_EMAIL_FIELDS.map(f => [f.key, problemWith(values[f.key])]));
  const canSubmit = DELIVERY_EMAIL_FIELDS.every(f => !problems[f.key]);

  const submit = () => {
    if (!canSubmit) { setTouched(Object.fromEntries(DELIVERY_EMAIL_FIELDS.map(f => [f.key, true]))); return; }
    onSubmit(Object.fromEntries(DELIVERY_EMAIL_FIELDS.map(f => [f.key, values[f.key].trim()])));
  };

  return (
    <Modal
      open
      onClose={onCancel}
      title={`Email delivery — ${client.clientCode}`}
      footer={(
        <>
          <button type="button" className="cs-btn" onClick={onCancel}>Cancel</button>
          <button type="button" className="cs-btn cs-btn--save" onClick={submit} disabled={!canSubmit}>Submit for approval</button>
        </>
      )}
    >
      <p className="br-sec-note">
        Invoices and statements will both be delivered by Email, so this client needs all three addresses below.
        They are written to Practice Engine, along with the delivery format, once the Billing Team approves.
        Separate several addresses with a semicolon.
      </p>
      {DELIVERY_EMAIL_FIELDS.map(f => (
        <div className="br-delivery-col" key={f.key} style={{ marginBottom: 10 }}>
          <label className="br-delivery-label" htmlFor={`dem-${f.key}`}>{f.label}</label>
          <input
            id={`dem-${f.key}`}
            className={`cs-input${touched[f.key] && problems[f.key] ? ' rbe-input--error' : ''}`}
            style={{ width: '100%', boxSizing: 'border-box', padding: '6px 8px' }}
            type="text"
            inputMode="email"
            autoComplete="off"
            value={values[f.key]}
            onChange={e => setValues(v => ({ ...v, [f.key]: e.target.value }))}
            onBlur={() => setTouched(t => ({ ...t, [f.key]: true }))}
            onKeyDown={e => { if (e.key === 'Enter') submit(); }}
          />
          {touched[f.key] && problems[f.key] && <span className="cs-field-error">{f.label}: {problems[f.key].toLowerCase()}.</span>}
        </div>
      ))}
    </Modal>
  );
}
